@if ((form && fieldName) || schema === null) {
  <div [formGroup]="form" style="min-width: 223px">
    <div>
      <p-float-label>
        <p-inputgroup>
          <ng-template [ngTemplateOutlet]="prefix"></ng-template>
          @if ((cacheParameters | async)?.isLoading) {
            <div style="height: 43.2px; width: 100%" class="overflow-hidden">
              <p-skeleton width="100%" height="43.2px" styleClass="mb-2" /><br />
              <span class="absolute top-4 right-2 z-10">
                <i class="pi spin autorenew s-loader"></i>
              </span>
            </div>
          } @else {
            <!--
            class="flex"
            autocompleteLabel
            -->
            <p-autoComplete
              #input
              [id]="fieldName.toString()"
              [inputId]="inputId"
              appendTo="body"
              [showClear]="!(isRequired() || readonly)"
              [suggestions]="(filteredOptions$ | async) ?? []"
              [dropdown]="!readonly"
              [readonly]="readonly"
              [showEmptyMessage]="true"
              [s-blur]="attribute?.dataClassification"
              [emptyMessage]="'No Results Found.'"
              [required]="isRequired()"
              [multiple]="multiple"
              [class.w-full]="multiple"
              (onSelect)="onSelection($event)"
              (onDropdownClick)="onDropDownClick($event)"
              [autoHighlight]="(filteredOptions$ | async)?.length === 1 ? true : false"
              (onClear)="onClear()"
              (onBlur)="onBlur($event)"
              [formControlName]="fieldName.toString()"
              (completeMethod)="queryFilter($event)"
              [placeholder]="label ? undefined : 'Enter ' + defaultText"
              [dataKey]="keyProperty"
              optionValue="id"
              [optionLabel]="displayFn.bind(this)"
            >
              <ng-template let-option #item>{{ option.__display }}</ng-template>
            </p-autoComplete>
          }
          <label [htmlFor]="fieldName.toString()" [class.ml-2]="(cacheParameters | async)?.isLoading"
            >{{ label }}
            @if (isRequired()) {
              <span style="color: red">*</span>
            }
          </label>
          <ng-template [ngTemplateOutlet]="suffix"></ng-template>
        </p-inputgroup>
      </p-float-label>
    </div>
    <div>
      @if (displayHint) {
        <small class="block">{{ displayHint }}</small>
      }
      <s-form-error-input
        [groupName]="groupName"
        [fieldName]="fieldName"
        [form]="form"
        [apiError]="apiError"
        [schema]="schema"
      />
    </div>
  </div>
}
